import { Controller } from "@hotwired/stimulus"

// Clones / removes ability-binding fieldsets in a per-slot list (abilities[] params).
export default class extends Controller {
  static targets = ["list", "template"]
  static values = { slotLabel: { type: String, default: "Binding" } }

  add(event) {
    event.preventDefault()
    if (!this.hasTemplateTarget || !this.hasListTarget) return

    const node = this.templateTarget.content.cloneNode(true)
    this.#prepareClone(node)
    this.listTarget.appendChild(node)
    this.#renumberLegends()
  }

  remove(event) {
    event.preventDefault()
    if (!this.hasListTarget) return

    const fieldset = event.currentTarget.closest("fieldset")
    if (!fieldset || !this.listTarget.contains(fieldset)) return

    fieldset.remove()
    this.#renumberLegends()
  }

  #prepareClone(fragment) {
    const uid = `new_${Date.now()}_${Math.floor(Math.random() * 10000)}`

    fragment.querySelectorAll("input, textarea, select").forEach((el) => {
      if (el.type !== "hidden") {
        if (el.tagName === "SELECT") {
          el.selectedIndex = 0
          el.value = ""
        } else {
          el.value = ""
        }
      }

      if (el.id) {
        const oldId = el.id
        const newId = `${oldId}_${uid}`
        el.id = newId
        const label = fragment.querySelector(`label[for="${oldId}"]`)
        if (label) label.setAttribute("for", newId)
      }
    })
  }

  #renumberLegends() {
    const label = this.slotLabelValue
    this.listTarget.querySelectorAll(":scope > fieldset legend").forEach((legend, i) => {
      legend.textContent = `${label} · ${i + 1}`
    })
  }
}
